export default __webpack_public_path__ + "static/media/PortabilityBlack.61af93bb.svg";